import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import React from 'react';

/**
 * Interface pour les props du composant UserSelect
 */
interface Props {
  /** Fonction appelée lors du changement de sélection */
  onChange?: (value: string) => any;
  /** Liste des utilisateurs disponibles */
  users: CRM.UserDocument[];
  /** ID de l'utilisateur actuellement sélectionné */
  value?: string;
  /** Indique si le composant est désactivé */
  disabled?: boolean;
  /** Label du champ de sélection */
  label?: string;
  /** Permet de désélectionner l'utilisateur */
  allowUnselect?: boolean;
}

/**
 * Composant de sélection d'utilisateur
 * 
 * Ce composant permet de :
 * - Sélectionner un utilisateur depuis une liste
 * - Afficher le nom d'affichage de chaque utilisateur
 * - Permettre la désélection si configuré
 * - Gérer l'état désactivé
 * 
 * Logique métier :
 * - Générique pour tous types d'utilisateurs avec displayName
 * - Option "Aucun" si allowUnselect est activé
 * - Retour de l'ID de l'utilisateur sélectionné
 * - Interface utilisateur cohérente avec Material-UI
 * 
 * @param onChange Fonction appelée lors du changement de sélection
 * @param users Liste des utilisateurs disponibles
 * @param value ID de l'utilisateur actuellement sélectionné
 * @param disabled Indique si le composant est désactivé
 * @param label Label du champ de sélection
 * @param allowUnselect Permet de désélectionner l'utilisateur
 * @returns Composant React de sélection d'utilisateur
 */
export const UserSelect: React.FC<Props> = ({
  onChange,
  users,
  value,
  disabled,
  label,
  allowUnselect
}) => {
  return (
    <FormControl variant="outlined" className="inputSize-lg">
      <InputLabel id="Utilisateur-select-label">{label ? label : 'Utilisateur'}</InputLabel>
      <Select
        labelId="Utilisateur-select-label"
        value={value || ''}
        label={label ? label : 'Utilisateur'}
        disabled={disabled}
        onChange={e => {
          const newSelected = users.find(user => user._id === e.target.value);

          if (/*(newSelected) && */onChange) {
            onChange(newSelected?._id || '');
          }
        }}
      >
        {allowUnselect && allowUnselect === true &&
          <MenuItem value={''} key={''}>
            Aucun
          </MenuItem>
        }
        {users.map(user => (
          <MenuItem value={user._id} key={user._id}>
            {user.displayName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
